import { states } from '../utils/form';
/**
 * Transforms state full name to abbreviation if applicable
 * e.g., "Texas" -> "TX", "California" -> "CA"
 */
function transformStateValue(fieldName, value) {
    if (fieldName === 'state' && value) {
        const stateData = states.find((s) => s.label.toLowerCase() === value.toLowerCase());
        return stateData ? stateData.value : value;
    }
    return value;
}
export function useFieldMapping({ fieldMapping, values, errors, setErrors, onFormError, onFieldChange, onFieldBlur, validationSchema, defaultValues, context = {}, }) {
    const handleFieldBlur = (e) => {
        const domFieldName = e.target.name;
        const apiFieldName = fieldMapping[domFieldName] || domFieldName;
        const rawValue = e.target.value || '';
        // Transform state full names to abbreviations for backend
        const value = transformStateValue(apiFieldName, rawValue);
        let errorsMap;
        const formValues = {
            ...defaultValues,
            ...values,
            [apiFieldName]: value,
        };
        try {
            validationSchema.validateSyncAt(apiFieldName, formValues, { context });
            // If validation passes, clear the error for this field
            const { [apiFieldName]: _, ...rest } = errors;
            errorsMap = { ...rest };
        }
        catch (err) {
            errorsMap = { ...errors, [apiFieldName]: err.message };
        }
        setErrors(errorsMap);
        onFormError(errorsMap);
        // Create a synthetic event with the API field name for the parent component
        const syntheticEvent = {
            ...e,
            target: {
                ...e.target,
                name: apiFieldName,
                value: value,
            },
        };
        onFieldBlur(syntheticEvent);
    };
    const handleFieldChange = (e) => {
        const domFieldName = e.target.name;
        const apiFieldName = fieldMapping[domFieldName] || domFieldName;
        const rawValue = e.target.value || '';
        // Transform state full names to abbreviations for backend
        const value = transformStateValue(apiFieldName, rawValue);
        // Only validate if there's already an error for this field
        // This clears errors as the user types but doesn't show new errors until blur
        if (errors[apiFieldName]) {
            let errorsMap;
            const formValues = {
                ...defaultValues,
                ...values,
                [apiFieldName]: value,
            };
            try {
                validationSchema.validateSyncAt(apiFieldName, formValues, { context });
                // If validation passes, clear the error for this field
                const { [apiFieldName]: _, ...rest } = errors;
                errorsMap = { ...rest };
                setErrors(errorsMap);
                onFormError(errorsMap);
            }
            catch (err) {
                // Keep the existing error, don't update it while typing
            }
        }
        // Create a synthetic event with the API field name for the parent component
        const syntheticEvent = {
            ...e,
            target: {
                ...e.target,
                name: apiFieldName,
                value: value,
            },
        };
        onFieldChange(syntheticEvent);
    };
    return {
        handleFieldChange,
        handleFieldBlur,
    };
}
//# sourceMappingURL=useFieldMapping.js.map